module.exports = __webpack_public_path__ + "fonts/gothica1-regular-webfont.9d28e16.woff";